<div class="textCenter loader-backdrop" *ngIf="loaderService.loading$ | async">
  <div class="custom-spinner"></div>
  <!-- <img src="./assets/imgs/loader.gif" width="100vw" height="100vw" alt="Loading..."> -->
  <div class="loader-text">
    {{ loaderService.message$ | async }}
  </div>
  
</div>
